export default "__VITE_ASSET__DL24saqX__"